import { useLanguage } from "../contexts/LanguageContext"
import { useEffect, useState } from "react"

export default function Hero() {
  const { t, currentLanguage } = useLanguage()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  // Function to get the appropriate image based on language
  const getLanguageImage = () => {
    const languageImageMap = {
      en: "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/2%20%281%29-9N1VISXYiHtmMQOnSV2qQaYj2POTT0.png",
      hi: "/hindi_home.jpg",
      ar: "/arabic_home.jpg",
      ur: "/urdu_home.jpg",
      fr: "/french_home.jpg",
      ko: "/korean_home.jpg",
      filipino: "/filipino_home.jpg",
      persian: "/persian_home.jpg",
      pashto: "/pashto_home.jpg"
    }

    return languageImageMap[currentLanguage] || languageImageMap.en
  }

  // Function to get the appropriate shipment image based on language
  const getLanguageShipmentImage = () => {
    const languageImageMap = {
      en: "/en_shipment.jpg",
      hi: "/hi_shipment.jpg",
      ar: "/ar_shipment.jpg",
      ur: "/ur_shipment.jpg",
      fr: "/french_shipment.jpg",
      ko: "/korean_shipment.jpg",
      filipino: "/filipino_shipment.jpg",
      persian: "/persion_shipment.jpg",
      pashto: "/pashto_shipment.jpg"
    }

    return languageImageMap[currentLanguage] || languageImageMap.en
  }

  // Function to get the appropriate transporter image based on language
  const getLanguageTransporterImage = () => {
    const languageImageMap = {
      en: "/en_transporter.jpg",
      hi: "/hi_transporter.jpg",
      ar: "/ar_transporter.jpg",
      ur: "/urdu_transporter.jpg",
      fr: "/french_transporter.jpg",
      ko: "/korean_transporter.jpg",
      filipino: "/filipino_transpoter.jpg",
      persian: "/persian_transporter.jpg",
      pashto: "/pashto_transporter.jpg"
    }

    return languageImageMap[currentLanguage] || languageImageMap.en
  }

  return (
    <section id="hero" className="min-h-screen relative overflow-hidden bg-gradient-to-br from-orange-600 via-orange-500 to-red-600">
      {/* Modern geometric background */}
      <div className="absolute inset-0">
        {/* Primary gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-orange-600/30 via-orange-500/20 to-red-600/30"></div>

        {/* Geometric patterns */}
        <div className="absolute inset-0 opacity-15">
          <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-orange-400 to-red-500 rounded-full blur-3xl transform -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute top-1/2 right-0 w-80 h-80 bg-gradient-to-br from-red-400 to-orange-500 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 left-1/3 w-72 h-72 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-full blur-3xl transform translate-y-1/2"></div>
        </div>

        {/* Grid pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
      </div>

      {/* Floating particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-orange-300/60 rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/4 w-1 h-1 bg-yellow-300/60 rounded-full animate-ping" style={{ animationDelay: "1s" }}></div>
        <div className="absolute bottom-1/3 left-1/5 w-1.5 h-1.5 bg-orange-400/60 rounded-full animate-pulse" style={{ animationDelay: "2s" }}></div>
        <div className="absolute top-2/3 right-1/3 w-1 h-1 bg-red-300/60 rounded-full animate-ping" style={{ animationDelay: "3s" }}></div>
      </div>

      <div className="relative z-10 min-h-screen flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">

            {/* Content Section */}
            <div className="space-y-8">
              <div className={`transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                {/* Badge */}
                <div className="inline-flex items-center px-4 py-2 bg-orange-500/20 border border-white/50 rounded-full text-orange-100 text-sm font-medium mb-6 backdrop-blur-sm">
                  <span className="w-2 h-2 bg-orange-400 rounded-full mr-2 animate-pulse "></span>
                  {t("hero.tagline")}
                </div>

                {/* Main Heading */}
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-3">
                  {/* <span className="bg-gradient-to-r from-orange-300 via-yellow-300 to-orange-200 bg-clip-text text-transparent">
                    {t("hero.mainHeadding.title1")}
                  </span>
                  <br /> */}
                  <span className="text-white">{t("hero.mainHeadding.title2")}</span>
                  <br />
                  <span className="bg-gradient-to-r from-yellow-300 via-orange-300 to-red-300 bg-clip-text text-transparent">
                    {t("hero.mainHeadding.title3")}
                  </span>
                </h1>
                {/* Slogan as a highlighted badge */}
                <div className="inline-flex items-center px-3 py-1 bg-white/20 border border-orange-200/30 rounded-full text-orange-50 text-base font-semibold mb-3 shadow-sm backdrop-blur-sm">
                  {/* <svg className="w-4 h-4 mr-2 text-yellow-300" fill="currentColor" viewBox="0 0 20 20"><circle cx="10" cy="10" r="10" /></svg> */}
                  {t("hero.mainHeadding.slogan")}
                </div>
                {/* Description */}
                <p className="text-xl text-white  max-w-lg leading-relaxed">
                  {t("hero.description")}
                </p>
              </div>

              {/* Stats Cards */}
              <div className={`grid grid-cols-3 gap-4 transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
                <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/20">
                  <div className="text-2xl font-bold text-white">{t("hero.cities_details")}</div>
                  <div className="text-gray-300 text-sm">{t("hero.cities")}</div>
                </div>
                <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/20">
                  <div className="text-2xl font-bold text-white">{t("hero.transporters_details")}</div>
                  <div className="text-gray-300 text-sm">{t("hero.transporters")}</div>
                </div>
                <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/20">
                  <div className="text-2xl font-bold text-white">{t("hero.shipments_details")}</div>
                  <div className="text-gray-300 text-sm">{t("hero.shipments")}</div>
                </div>
              </div>
            </div>

            {/* Phone Mockup Section */}
            <div className={`relative transition-all duration-1000 delay-700 ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              <div className="relative flex justify-center items-center">
                {/* Main Phone */}
                <div className="relative z-30">
                  <div className="relative">
                    <img
                      src={getLanguageImage()}
                      alt="Makkok App"
                      className="h-[500px] w-auto rounded-3xl shadow-2xl animate-float-smooth"
                    />
                    {/* Glow effect */}
                    <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-orange-400/20 via-red-400/20 to-yellow-400/20 blur-xl -z-10 animate-glow-pulse"></div>
                  </div>
                </div>

                {/* Secondary Phone - Left */}
                <div className="absolute -left-20 top-20 z-20 opacity-70 hidden lg:block">
                  <img
                    src={getLanguageTransporterImage()}
                    alt="App Feature"
                    className="h-80 w-auto rounded-2xl shadow-xl animate-float-gentle-left"
                  />
                </div>

                {/* Secondary Phone - Right */}
                <div className="absolute -right-20 top-32 z-20 opacity-70 hidden lg:block">
                  <img
                    src={getLanguageShipmentImage()}
                    alt="App Dashboard"
                    className="h-72 w-auto rounded-2xl shadow-xl animate-float-gentle-right"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
